import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/footer'

import Projects from '../components/projects'

import '../assets/scss/main.scss'

import favicon from '../assets/images/favicon.ico'
import shareImage from '../assets/images/banner.jpg'

const siteUrl = 'https://collectivecapital.com.au'
const defaultDescription =
  'Collective Capital Investments is a specialised Australian property investment group taking a collaborative, co-investment approach to commercial property.'

class Layout extends Component {

  render() {
    let { children } = this.props
    return (
      <>
        <Helmet
          defaultTitle="Collective Capital Investments | Australian Property Investment Group"
          titleTemplate="%s | Collective Capital Investments"
        >
          <html lang="en" />
          <link rel="shortcut icon" href={favicon} type="image/x-icon" />

          {/* Fallback meta — overridden per page by the SEO component */}
          <meta name="description" content={defaultDescription} />
          <meta name="keywords" content="collective capital, property investment, commercial property, co-investment, Australia, Melbourne" />

          {/* Open Graph / social defaults */}
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Collective Capital Investments" />
          <meta property="og:image" content={`${siteUrl}${shareImage}`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image" content={`${siteUrl}${shareImage}`} />
        </Helmet>
        <div className="wrapper">
          <div className="wrapper__site">
            <Header />
            <main className="site-wrapper">
              { children }
            </main>
            <Footer />
          </div>
          <div className="wrapper__projects">
            <Projects />
          </div>
        </div>

      </>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
